import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';

export default function PoliticaPrivacidad() {
  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Politica de Privacidad' }]} />
      <div style={{ maxWidth:860, margin:'0 auto', padding:'60px 24px' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:42, color:'var(--forest)', marginBottom:8 }}>Politica de Privacidad</h1>
        <div style={{ width:60, height:4, background:'#9FBE6A', borderRadius:2, marginBottom:32 }} />
        <p style={{ fontSize:13, color:'var(--ink-faint)', marginBottom:32 }}>Ultima actualizacion: Abril 2026</p>

        {[
          {
            titulo: '1. Responsable del tratamiento',
            texto: 'Wawita Eco Friendly, con domicilio en Pasto, Narino, Colombia, es responsable del tratamiento de los datos personales recolectados a traves de su sitio web wawita.co y sus canales digitales. Contacto: contacto@wawitaeco.com'
          },
          {
            titulo: '2. Datos que recolectamos',
            texto: 'Recolectamos nombre completo, correo electronico, numero de telefono, direccion de entrega y datos de pago (procesados por terceros). Tambien recolectamos datos de navegacion como direccion IP y cookies con fines estadisticos.'
          },
          {
            titulo: '3. Finalidad del tratamiento',
            texto: 'Los datos son utilizados para: procesar y gestionar pedidos, enviar confirmaciones y notificaciones de compra, gestionar cuentas de usuario, enviar comunicaciones comerciales (previo consentimiento), mejorar nuestros servicios y cumplir obligaciones legales.'
          },
          {
            titulo: '4. Base legal',
            texto: 'El tratamiento de sus datos se realiza con base en el consentimiento del titular, la ejecucion de un contrato de compraventa, el cumplimiento de obligaciones legales y el interes legitimo de Wawita Eco Friendly, conforme a la Ley 1581 de 2012 y el Decreto 1377 de 2013 de Colombia.'
          },
          {
            titulo: '5. Comparticion de datos',
            texto: 'No vendemos ni cedemos sus datos a terceros con fines comerciales. Podemos compartir datos con: operadores logisticos para entregas, pasarelas de pago para procesar transacciones, proveedores de servicios tecnologicos bajo acuerdos de confidencialidad.'
          },
          {
            titulo: '6. Derechos del titular',
            texto: 'Conforme a la Ley 1581 de 2012, usted tiene derecho a: conocer, actualizar y rectificar sus datos; solicitar prueba de su autorizacion; ser informado del uso de sus datos; presentar quejas ante la Superintendencia de Industria y Comercio; revocar su autorizacion y solicitar la supresion de sus datos.'
          },
          {
            titulo: '7. Seguridad',
            texto: 'Implementamos medidas tecnicas y organizativas para proteger sus datos contra acceso no autorizado, perdida o destruccion, incluyendo cifrado SSL, acceso restringido y copias de seguridad periodicas.'
          },
          {
            titulo: '8. Cookies',
            texto: 'Utilizamos cookies propias para el funcionamiento del sitio (sesion, carrito de compras). Puede configurar su navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.'
          },
          {
            titulo: '9. Menores de edad',
            texto: 'Nuestros servicios no estan dirigidos a menores de 14 anos. No recolectamos intencionalmente datos de menores sin autorizacion de sus padres o tutores legales.'
          },
          {
            titulo: '10. Contacto',
            texto: 'Para ejercer sus derechos o resolver dudas sobre esta politica, escribanos a: contacto@wawitaeco.com o al WhatsApp +57 311 340 7979. Pasto, Narino, Colombia.'
          },
        ].map(s => (
          <div key={s.titulo} style={{ marginBottom:32 }}>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:20, color:'var(--forest)', marginBottom:12 }}>{s.titulo}</h2>
            <p style={{ fontSize:15, color:'var(--ink-mid)', lineHeight:1.8 }}>{s.texto}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
